export default __webpack_public_path__ + "static/media/discordbutton.560670f2.svg";